import React, { useState } from 'react';
import { t } from '../../../utils/textUtils';
import {
  Box,
  Grid,
  TextField,
  Typography,
  MenuItem,
  Button,
  IconButton,
  Paper,
  Stack,
  Chip
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import ApartmentIcon from '@mui/icons-material/Apartment';

const tipeBangunanOptions = [
  'PRE-FABRICATED',
  'PANEL SYSTEM',
  'MODULAR SYSTEM',
  'KNOCK DOWN'
];

const WorkPlanForm = ({ formData, onChange, errors = {} }) => {
  const [fileName, setFileName] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setFileName(file.name);
      onChange({ layoutDesainFile: file });
    }
  };

  const handleRemoveFile = () => {
    setFileName('');
    onChange({ layoutDesainFile: null });
  };

  return (
    <Box>
      <Paper
        variant="outlined"
        sx={{
          p: 2.5,
          mb: 2.5,
          borderRadius: 2,
          borderColor: 'divider',
          bgcolor: '#F8FAFC'
        }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: 2,
              bgcolor: '#ffffff',
              boxShadow: '0 8px 20px rgba(15, 23, 42, 0.08)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <ApartmentIcon sx={{ color: '#16A34A' }} />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>
              {t('RENCANA & VOLUME PEKERJAAN')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('Tentukan detail volume pekerjaan dan spesifikasi teknis proyek.')}
            </Typography>
          </Box>
        </Stack>
      </Paper>

      <Paper 
          elevation={0}
          sx={{ 
            p: { xs: 2, sm: 3 }, 
            borderRadius: 2, 
            border: '1px solid',
            borderColor: 'rgba(15, 23, 42, 0.1)',
            bgcolor: '#FFFFFF',
            boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)'
          }}
        >
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1e40af', mb: 0.5 }}>
              {t('VOLUME PEKERJAAN')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('Tentukan detail volume pekerjaan dan spesifikasi teknis proyek.')}
            </Typography>
          </Box>

          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label={t('JUMLAH UNIT BANGUNAN (LEVEL 2)')}
                name="jumlahUnitBangunan"
                type="number"
                value={formData.jumlahUnitBangunan || formData.jumlahUnitModular}
                onChange={handleChange}
                error={!!errors.jumlahUnitBangunan}
                helperText={errors.jumlahUnitBangunan}
                InputProps={{ inputProps: { min: 1 } }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: '#3B82F6'
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3B82F6'
                    }
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                select
                label={t('TIPE BANGUNAN')}
                name="tipeBangunan"
                value={formData.tipeBangunan || formData.tipePrefabrikasi}
                onChange={handleChange}
                error={!!errors.tipeBangunan}
                helperText={errors.tipeBangunan || t('Pilih tipe bangunan yang akan digunakan')}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: '#3B82F6'
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3B82F6'
                    }
                  }
                }}
              >
                {tipeBangunanOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {t(option)}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label={t('LUAS TOTAL LAHAN (M²)')}
                name="luasTotalLahan"
                type="number"
                value={formData.luasTotalLahan}
                onChange={handleChange}
                error={!!errors.luasTotalLahan}
                helperText={errors.luasTotalLahan}
                InputProps={{ inputProps: { min: 0, step: 0.01 } }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: '#3B82F6'
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3B82F6'
                    }
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label={t('LUAS TOTAL BANGUNAN (M²)')}
                name="luasTotalBangunan"
                type="number"
                value={formData.luasTotalBangunan}
                onChange={handleChange}
                error={!!errors.luasTotalBangunan}
                helperText={errors.luasTotalBangunan}
                InputProps={{ inputProps: { min: 0, step: 0.01 } }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: '#3B82F6'
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3B82F6'
                    }
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1e40af', mb: 2 }}>
                {t('UPLOAD GAMBAR LAYOUT (OPSIONAL)')}
              </Typography>

              <Paper
                variant="outlined"
                sx={{
                  p: 2.5,
                  borderRadius: 2,
                  borderStyle: 'dashed',
                  borderColor: 'rgba(59, 130, 246, 0.3)',
                  bgcolor: 'linear-gradient(135deg, rgba(59, 130, 246, 0.02), rgba(30, 64, 175, 0.02))'
                }}
              >
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'flex-start', sm: 'center' }}>
                  {!fileName ? (
                    <Button
                      component="label"
                      variant="outlined"
                      startIcon={<CloudUploadIcon />}
                      sx={{ 
                        color: '#3B82F6', 
                        borderColor: 'rgba(59, 130, 246, 0.5)',
                        '&:hover': {
                          borderColor: '#3B82F6',
                          bgcolor: 'rgba(59, 130, 246, 0.04)'
                        }
                      }}
                    >
                      {t('PILIH FILE')}
                      <input
                        type="file"
                        hidden
                        accept="image/*,.pdf,.dwg"
                        onChange={handleFileChange}
                      />
                    </Button>
                  ) : (
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Chip 
                        label={fileName} 
                        variant="outlined"
                        sx={{ 
                          borderColor: 'rgba(59, 130, 246, 0.3)',
                          color: '#1e40af',
                          fontWeight: 500
                        }} 
                      />
                      <IconButton
                        size="small"
                        onClick={handleRemoveFile}
                        sx={{ 
                          color: '#ef4444',
                          '&:hover': {
                            bgcolor: 'rgba(239, 68, 68, 0.04)'
                          }
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Stack>
                  )}
                  <Typography variant="body2" sx={{ color: '#64748B' }}>
                    {t('Format: JPG, PNG, PDF, DWG (maks. 10MB)')}
                  </Typography>
                </Stack>
              </Paper>
            </Grid>
          </Grid>
        </Paper>
    </Box>
  );
};

export default WorkPlanForm;
